import React from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { addFAQCategory, addJobsFAQCategory, updateFAQCategory, updateJobsFAQCategory } from "../../../actions/utilitiesAction";
import AddFAQCategory from '../../../component/Utilities/JobsFAQs/AddCategory';
import constant from "../../../constant";

const AddCategory = () => {

    const [response, setResponse] = React.useState({})
    const [showMsg, setShowMsg] = React.useState(false)
    const navigate = useNavigate()

    const onSubmit = (model) => {
        debugger
        if (model.type === 'ADD') {
            addJobsFAQCategory(model).then((res) => {
                setResponse(res)
                setShowMsg(true)
                setTimeout(() => {
                    setShowMsg(false)
                    if (res.status) {
                        window.location.href = constant.component.jobsfaqlistcategory.url;
                    }
                }, 7000)

                // if (res.status) {
                //     alert(res.messageCode)
                //     window.location.href = constant.component.faqlistcategory.url;
                // }
            }).catch((err) => {
                alert(err)
            })
        } else {
            updateJobsFAQCategory(model).then((res) => {
                if (res.status) {
                    navigate(constant.component.jobsfaqlistcategory.url)
                } else {
                    setResponse(res)
                    setShowMsg(true)
                    setTimeout(() => {
                        setShowMsg(false)
                    }, 7000)
                }
            }).catch((err) => {
                alert(err)
            })
        }

    }


    return (
        <React.Fragment>
            <AddFAQCategory onSubmit={(data) => onSubmit(data)} response={response} showMsg={showMsg} />
        </React.Fragment>
    )
}

export default AddCategory